import React from 'react';
import PropTypes from 'prop-types';

import ActionIndicatorIcon from './action_indicator_icon.jsx';


export const getTileHoverDisplayText = (indicatorType)=> {
  switch (indicatorType) {

  case 'video':
    return 'Click to play video';

  case 'other':
    return 'Click to download';

  case 'pdf':
  case 'photo':
  case 'ppt':
  case 'embed':
    return 'Click to view';

  case 'link': // Meaning external-link
    return 'Click to visit link';

  case 'internal-link':
    return 'Click to navigate';

  default:
    throw new Error(`Unexpected indicatorType: ${indicatorType}`);
  }
};


const GridTileHover = ({ style, indicatorType })=> (
  <div aria-hidden="true" className="tile-action-hover-container" style={style}>
    <div className="tile-action-hover-background"></div>
    <div className={'tile-action-hover-contents tile-action-' + indicatorType}>
      <div className="tile-action-hover-icon-wrapper">
          <ActionIndicatorIcon indicatorType={indicatorType} />
          <i className="zfe-icon zfe-icon-circle"></i>
      </div>
      <div className="tile-action-hover-text">
        { getTileHoverDisplayText(indicatorType) }
      </div>
    </div>
  </div>
);
    


GridTileHover.propTypes = {
  indicatorType: PropTypes.string.isRequired,
  // style should at least have top, left, right, and bottom
  style: PropTypes.objectOf(PropTypes.string).isRequired
};

export default GridTileHover;
